import { Col } from 'antd';
import { BaseStyle, Font } from 'src/styles';

import { MButton } from '../FormComponents/MButton/MButton';
import { MModalV2 } from '../MModal/MModalv2';
import { MSpinner } from '../MSpinner/MSpinner';
import { SubmissionResult } from '../SubmissionResult/SubmissionResult';

export interface ConfirmActionModalProps {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  title: string;
  message?: string;
  successMessage?: string;
  errorMessage?: string;
  isSuccess?: boolean;
  isError?: boolean;
  onClose?: () => void;
}

export const ConfirmActionModal = ({
  title,
  message,
  isOpen,
  isLoading,
  onCancel,
  onOk,
  onClose,
  isSuccess,
  isError,
  successMessage,
  errorMessage,
}: ConfirmActionModalProps) => {
  const _onClose = () => {
    onClose?.();
  };

  const renderBaseFooter = () => {
    return (
      <Col span={24} className={BaseStyle.levelRight}>
        <MButton type='tertiary' onClick={onCancel} disabled={isLoading} testId={'no-btn'}>
          No
        </MButton>
        <MButton type='primary' onClick={onOk} disabled={isLoading} testId={'yes-btn'}>
          Yes
        </MButton>
      </Col>
    );
  };

  const renderModal = () => {
    if (isLoading) {
      return {
        body: (
          <Col span={24} className={BaseStyle.level}>
            <MSpinner height='100px' />
          </Col>
        ),
        footer: renderBaseFooter(),
      };
    }

    if (isSuccess) {
      return {
        body: <SubmissionResult type='success' message={successMessage} />,
        footer: (
          <MButton type='primary' onClick={_onClose} testId={'success-ok-btn'}>
            OK
          </MButton>
        ),
      };
    }

    if (isError) {
      return {
        height: 200,
        body: <SubmissionResult type='error' message={errorMessage} />,
        footer: (
          <MButton type='primary' onClick={_onClose} testId={'error-ok-btn'}>
            OK
          </MButton>
        ),
      };
    }

    return {
      body: <p className={Font.lg}>{message}</p>,
      footer: renderBaseFooter(),
    };
  };

  return <MModalV2 title={title} open={isOpen} onClose={_onClose} width={550} height={150} {...renderModal()} />;
};
